module.exports = __webpack_public_path__ + "static/img/kyht.afa2ecd2.png";